/**
 * Relay Mutation: Get Organizations With Unpaid Invoices
 * 
 * Fetches aggregated summary of all organizations that have unpaid invoices.
 * Returns organization names, invoice counts, and total amounts by currency.
 * 
 * Permission: Developer only
 * Created: 2025-12-07
 * Updated: 2025-12-07 20:02 - Fixed cache issue
 */

import Relay from 'react-relay';

export default class GetOrganizationsWithUnpaidInvoicesMutation extends Relay.Mutation {
	getMutation() {
		return Relay.QL`mutation { getOrganizationsWithUnpaidInvoices }`;
	}

	getVariables() {
		// mutationWithClientMutationId automatically wraps this in { input: {...}, clientMutationId: ... }
		// So we return empty object which becomes { input: {}, clientMutationId: "..." }
		return {};
	}

	getFatQuery() {
		return Relay.QL`
			fragment on GetOrganizationsWithUnpaidInvoicesPayload {
				organizations {
					organisationId
					organisationName
					totalUnpaidCZK
					totalUnpaidEUR
					totalUnpaidOther
					totalUnpaidOtherCurrency
					invoiceCount
					oldestDueDate
				}
			}
		`;
	}

	getConfigs() {
		return [{
			type: 'REQUIRED_CHILDREN',
			children: [
				Relay.QL`
					fragment on GetOrganizationsWithUnpaidInvoicesPayload {
						organizations {
							organisationId
							organisationName
							totalUnpaidCZK
							totalUnpaidEUR
							totalUnpaidOther
							totalUnpaidOtherCurrency
							invoiceCount
							oldestDueDate
						}
					}
				`
			]
		}];
	}
}
